// USD ↔ GTQ (Guatemalan Quetzal) approx rate
export const FX = { USD: 1, GTQ: 7.75 };

export function formatPrice(priceUsd, currency = "USD") {
  const value = priceUsd * (FX[currency] || 1);
  if (currency === "GTQ") {
    return `Q ${value.toLocaleString("es-GT", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
  }
  return `$ ${value.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} USD`;
}

export const CATEGORY_LABELS = {
  talleres: "Talleres",
  cursos: "Cursos",
  diplomados: "Diplomados",
  masters: "Masters",
  licenciaturas: "Licenciaturas",
  maestrias: "Maestrías",
  doctorados: "Doctorados",
  certificaciones: "Certificaciones",
};

export const CATEGORY_ICONS = {
  talleres: "Hammer",
  cursos: "BookOpen",
  diplomados: "Award",
  masters: "Crown",
  licenciaturas: "GraduationCap",
  maestrias: "Sparkles",
  doctorados: "Trophy",
  certificaciones: "BadgeCheck",
};

export const CATEGORY_IMAGES = {
  talleres: "https://images.pexels.com/photos/15141493/pexels-photo-15141493.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cursos: "https://images.unsplash.com/photo-1543269865-cbf427effbad?crop=entropy&cs=srgb&fm=jpg&q=85",
  diplomados: "https://images.pexels.com/photos/8199178/pexels-photo-8199178.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  masters: "https://images.pexels.com/photos/37758607/pexels-photo-37758607.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  licenciaturas: "https://images.pexels.com/photos/8199651/pexels-photo-8199651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  maestrias: "https://images.pexels.com/photos/37758607/pexels-photo-37758607.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  doctorados: "https://images.pexels.com/photos/38846535/pexels-photo-38846535.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  certificaciones: "https://images.pexels.com/photos/7648310/pexels-photo-7648310.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_d4a80907-9d5e-4ade-a6ba-acf2d37fe16e/artifacts/ophkyhav_377B89F4-A6FE-4797-8AA6-699869314518.png";
